export default "<a *ngIf='!!data' class=\"cursor-pointer\" pTooltip='{{data.Value}}' tooltipPosition=\"top\" (click)='navigate()'>{{data.Value}}</a>\r\n";